import store from '@/store'

export default async (to, from, next) => {
  store.dispatch('wait/start', 'app loading', { root: true })
  await store.dispatch('Order/fetchOrdersByUserId', { status: 'new,pending,paid,rejected', type: 'newLineOfficialAccount,transferLineOfficialAccount' })
  store.dispatch('wait/end', 'app loading', { root: true })
  next()
}
